import { zod } from '@acme/core'
import { Transaction } from '@cel_cash/core/types'
import { z } from 'zod'
import ApiService from '../api.service'
import { Cliente } from './clientes'

export type ReajusteAnual = z.infer<typeof zod.ReajusteAnualSchema>

export const reajustesAnuais = new ApiService<ReajusteAnual>(
    'parametros-financeiros/reajustes-anuais',
)

export const transacoesCliente = new ApiService<Transaction>(
    'parametros-financeiros/transacoes',
)

export const planoDiferenciado = new ApiService<Cliente['PlanoDiferenciado']>(
    'parametros-financeiros/plano-diferenciado',
)
